import { render, staticRenderFns } from "./crowd-counting-va.vue?vue&type=template&id=73610ead&"
import script from "./crowd-counting-va.vue?vue&type=script&lang=ts&"
export * from "./crowd-counting-va.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-counting-va.vue?vue&type=style&index=0&id=73610ead&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports